import { Table } from '@tanstack/react-table';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { MaskTemplateEntity } from '../../containers/mask-overlays/mask-overlay';

export function useErpHandlersTemplateV8(
  table: Table<unknown>,
  columnId = 'businessPartnerContactCombined.businessPartner.data.id',
  erpEntity?: Entities.customer | Entities.supplier,
  forwardContact?: boolean
): MaskTemplateEntity {
  const shouldForwardContact = forwardContact || false;

  const bpCol = table.getColumn(columnId);
  const bpFilterValue = bpCol?.getFilterValue() as any;
  const bp = bpFilterValue?.value?.[0];

  const contactColumnId = 'businessPartnerContactCombined.contact.id';
  const contactCol = table.getColumn(contactColumnId);
  const contactFilterValue = contactCol?.getFilterValue() as any;
  const contactId = contactFilterValue?.value?.[0]?.id;

  const defaultBp =
    bp?.id && bp?.__typename
      ? {
          ids: [bp?.id],
          entity:
            bp?.__typename === 'Kunde' ? Entities.customer : Entities.supplier,
        }
      : null;

  const template: MaskTemplateEntity = erpEntity
    ? {
        ids: [bp?.id],
        entity: erpEntity,
      }
    : defaultBp;

  if (template && shouldForwardContact)
    template.entity = contactId
      ? `contact:${contactId}:${template?.entity}`
      : template.entity;

  return template;
}
